import { ReactNode } from 'react'

import { OnboardingStickyNav } from '@/features/onboarding/shared/OnboardingStickyNav'
import { useFixedFooterOffset } from '@/features/onboarding/shared/useFixedFooterOffset'

export const OnboardingScreen = ({
  children,
  continueDisabled = false,
  onBackClick,
  onContinueClick,
}: {
  children?: ReactNode
  continueDisabled?: boolean
  onBackClick?: () => void
  onContinueClick?: () => void
}) => {
  const leftOffset = useFixedFooterOffset()

  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col space-y-4 max-w-[584px] pb-[120px] max-sm:pb-6">
        <div className="px-8 pt-2 pb-6">{children}</div>
      </div>

      <OnboardingStickyNav
        leftOffset={leftOffset}
        // Page chrome, so it tracks Layout's own max-w-[1200px], not this
        // page's narrower reading column.
        className="mx-auto max-w-[1200px]"
        onBack={onBackClick}
        onContinue={onContinueClick}
        continueDisabled={continueDisabled}
      />
    </div>
  )
}
